import React, { createContext, useContext, useState, useCallback } from "react"
import { CRXSettingsModal } from "../CRXSettings.jsx"

const CRXModalContext = createContext({
	isOpen: false,
	open: () => {},
	close: () => {},
})

export const useCRXModal = () => useContext(CRXModalContext)

export const CRXModalProvider = ({ children }) => {
	const [isOpen, setIsOpen] = useState(false)

	const open = useCallback(() => setIsOpen(true), [])
	const close = useCallback(() => setIsOpen(false), [])

	return (
		<CRXModalContext.Provider value={{ isOpen, open, close }}>
			{children}
			<CRXSettingsModal open={isOpen} setOpen={setIsOpen} />
		</CRXModalContext.Provider>
	)
}
